import React, { useState, useRef, useEffect } from "react";
import usePuskesmas from "../hooks/usePuskesmas";
import { useParams } from 'react-router-dom';
import apiService from "apiService";


const ClinicScreen = ({ puskesmas, socket }) => {
    const { id, clinic } = useParams();
    const [queue, setQueue] = useState("000");
    const [refKiaClinic, setKia] = useState([]);


    const getClinics = async (e) => {
        const res = await apiService.get(
            "/apm/clinics/read/" + puskesmas.code + "/2/0"
        );
        const kia = [];

        if (res.code === 200) {
            res.data.map((cl, key) => {
                if (cl.clinic.child.length > 0) {
                    if (parseInt(cl.clinic.id) === parseInt(id)) {

                        cl.clinic.child.map((d, k) => {
                            kia.push(d.clinic_id)
                        })
                    }
                }
            })
            setKia(kia);
        }

    };
    //   useEffect(() => {
    //      getClinics()
    //   }, [refKiaClinic.length])

    useEffect(() => {
        getClinics()
        socket.on("updateCurrentQueue", (data) => {
            if(refKiaClinic.length > 0 && refKiaClinic.includes(data.clinicId)) {
                data.clinicId = id
            }
            if (parseInt(data.clinicId) === parseInt(id)) {
                setQueue(data.currentQueue)
            }
            console.log(data)
        }
        );
    }, [refKiaClinic.length])
    
    return (
        <div className="main-content">
            {/* Header */}
            <div className="header bg-gradient-success py-3 py-lg-3 pt-lg-3 ">
                <div className="container">
                    <div className="header-body text-center mb-1">
                        <div className="row justify-content-center">
                            <div className="col-xl-5 col-lg-6 col-md-8 px-5 mt-4">
                                <h1 className="text-white">{ JSON.parse(localStorage.getItem('userData')) ? JSON.parse(localStorage.getItem('userData')).name :''}</h1>
                                {/* <h2 className="text-white text-center ">{puskesmas ? puskesmas.address : 'Alamat Puskesmas'}</h2> */}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Page content */}
            <div className="container ">
                <div className="row justify-content-center">
                    <div className="col-lg-10 col-md-12 pt-lg-3">
                        <div className="card bg-secondary border-0 mb-0">
                            {/* <div className="card-header bg-transparent pb-1">
                                <h1 className="text-black text-center ">Antrian</h1>
                                <h1 className="text-black text-center ">{clinic}</h1>
                            </div> */}
                            <div className="card-body px-lg-5 py-lg-5 mt--4 pb-2">
                                <div className={"card-body bg-warning"}>
                                    <div>
                                        <h1 className="text-center" style={{ fontSize: "150px" }}>
                                            <font className="text-yellow">{queue}</font>
                                            <font className="text-white">
                                                {/* 000 */}
                                            </font>
                                        </h1>
                                        <h1
                                            className="text-center display-1 text-white blinking"
                                            style={{ fontSize: "50px" }}
                                        >
                                            {/* {notification ? ( */}
                                            <>
                                                <i className="fas fa-angle-double-right mr-2"></i>
                                                {/* <font>{place.toUpperCase() || ""}</font> */}
                                                <font style={{ fontSize: "100px" }}>{clinic}</font>
                                            </>
                                            {/* ) : (
                                                    ""
                                                )} */}
                                        </h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <footer className="bg-gradient-success" id="footer-main">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-xl-12">
                            <div className="text-center text-xl-left text-muted">
                                <h1 className="text-black  text-center">{}</h1>
                                <h1 className="text-black  text-center"></h1>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>

        </div>

    )
}

export default usePuskesmas(ClinicScreen)